import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import IssueDetail from 'components/Agile/issue/issueDetail';
import IssueTable from 'components/Agile/issue/issueTable';
import IssueAdd from 'components/Agile/issue/issueMaintenance/issueAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchIssues,
    handleIssueRequestClose,
    showIssueLoader,
    onAddIssue,
    onToggleIssueDrawer,
} from 'actions/issue';
import {
    fetchFeatures,
} from 'actions/feature';
import {
    fetchMembers,
} from 'actions/member';

const Component = () => {
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const loader = useSelector(state => state.issues.loader);
    const alertMessage = useSelector(state => state.issues.alertMessage);
    const showMessage = useSelector(state => state.issues.showMessage);
    const noContentFoundMessage = useSelector(state => state.issues.noContentFoundMessage);
    const drawerState = useSelector(state => state.issues.drawerState);
    const issue = useSelector(state => state.issues.issue);
    const issueList = useSelector(state => state.issues.issueList);

    useEffect(() => {
        dispatch(showIssueLoader());
        dispatch(fetchIssues());
        dispatch(fetchFeatures());
        dispatch(fetchMembers());
    }, []);

    const issueSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.issues" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddIssue())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="issue.addIssue" /></span>
                        </Button>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    const issueRequestClose = () => {
        dispatch(handleIssueRequestClose());
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleIssueDrawer())}
                        sidebar={issueSideBar(issue)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {issueSideBar(issue)}
                </div>
                <div className="module-box">
                    <div className="module-box-content">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={() => dispatch(onToggleIssueDrawer())}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                issueList && issueList.length > 0 ?
                                    <Fragment>
                                        <div className="app-main-content">
                                            <IssueTable />
                                            <div style={{ marginTop: 10 }}>
                                                <IssueDetail />
                                            </div>
                                        </div>
                                    </Fragment>
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>

                    </div>
                </div>
            </div>
            <IssueAdd />

            {showMessage && NotificationManager.success(alertMessage, issueRequestClose())}
            <NotificationContainer />

        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/issue/component.js